export const LOGIN = "/login"
export const RECIPES = "/recipes"
export const NEW_RECIPE = "/new-recipe"
export const EDIT_RECIPE = "/recipes/:id"
export const PDF_RECIPE = "/recipes/:id/pdf"
export const SETTINGS = "/settings"
export const HOME = "/"
